import script from "./HelpDialogChatLog.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpDialogChatLog.vue?vue&type=script&setup=true&lang=js"

import "./HelpDialogChatLog.vue?vue&type=style&index=0&id=e13a6810&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e13a6810"]])

export default __exports__